// src/store/bankSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import DropdownService from 'src/services/DropdownService'

export const fetchBankList = createAsyncThunk(
  'bank/fetchBankList',
  async (_, { rejectWithValue }) => {
    try {
      const res = await DropdownService.getListAllBank()
      return res?.success?.data || []
    } catch (error) {
      return rejectWithValue("Không thể tải danh sách ngân hàng")
    }
  }
)

const bankSlice = createSlice({
  name: 'bank',
  initialState: {
    list: [],
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchBankList.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchBankList.fulfilled, (state, action) => {
        state.loading = false
        state.list = action.payload
      })
      .addCase(fetchBankList.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  }
})

export default bankSlice.reducer
